import { defineStore } from 'pinia'
import { getActivityListApi, getActivityCategoryListApi } from '@/service/activity'

export const useActivityStore = defineStore('activity', {
  state: () => ({
    activityList: [],
    activityCategoryList: [],
  }),
  actions: {
    async getActivityList() {
      const res = await getActivityListApi()
      this.activityList = res.data
    },
    async getActivityCategoryList() {
      const res = await getActivityCategoryListApi()
      this.activityCategoryList = res.data
    },
    async getActivityDetail(id: string) {
      if (this.activityList.length === 0) return ''
      const activity = this.activityList.find((item) => item.ID === Number(id))
      if (activity) {
        return activity
      }
      return ''
    },
  },
})
